module.exports = __webpack_public_path__ + "static/media/brownie-points-logo-standard-white.f65e61db.svg";